import { Doctor, User } from '../types/api';

export function mapStoredUserToDoctor(u: User): Doctor {
  return {
    id: u.id,
    name: u.fullName,
    mcr: u.mcr || '',
    displayName: u.displayName || u.fullName,
    customText1: u.customText1 || '',
    customText2: u.customText2 || '',
    maskOn: u.maskOn || false,
    code: u.code || '',
    username: u.username || '',
    roleId: u.roleId,
  };
}

export function parseStoredUser(): User | null {
  const raw = localStorage.getItem('user');
  if (!raw) return null;
  try {
    return JSON.parse(raw) as User;
  } catch {
    return null;
  }
}
